module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_8004.30338d5b.png";